import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PiggyBank } from "lucide-react";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await register(email, password, name);
    setLoading(false);
    if (res.ok) {
      toast.success("Compte créé !");
      navigate("/");
    } else {
      toast.error(res.error || "Erreur lors de la création");
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center p-6">
      <div className="max-w-md w-full">
        <div className="flex items-center gap-2 mb-8 justify-center">
          <div className="w-10 h-10 bg-stone-900 rounded-xl flex items-center justify-center">
            <PiggyBank className="w-5 h-5 text-white" />
          </div>
          <span className="font-display text-xl font-bold">Budgeo</span>
        </div>
        <div className="bg-white rounded-2xl border border-stone-200 p-8 shadow-[0_2px_8px_rgba(0,0,0,0.04)]">
          <h1 className="font-display text-3xl font-bold mb-2 tracking-tight">Créer un compte</h1>
          <p className="text-stone-500 mb-6 text-sm">Commencez à gérer votre budget en 30 secondes.</p>
          <form onSubmit={onSubmit} className="space-y-4">
            <div className="space-y-1.5">
              <Label htmlFor="name">Nom</Label>
              <Input id="name" value={name} onChange={(e) => setName(e.target.value)} required
                     data-testid="register-name-input" className="rounded-xl h-11" placeholder="Marie Dupont" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required
                     data-testid="register-email-input" className="rounded-xl h-11" placeholder="vous@example.com" />
            </div>
            <div className="space-y-1.5">
              <Label htmlFor="password">Mot de passe (min 6 caractères)</Label>
              <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                     data-testid="register-password-input" className="rounded-xl h-11" placeholder="••••••••" />
            </div>
            <Button type="submit" disabled={loading}
                    className="w-full h-11 rounded-xl bg-stone-900 hover:bg-stone-800"
                    data-testid="register-submit-button">
              {loading ? "Création..." : "Créer mon compte"}
            </Button>
          </form>
          <p className="text-sm text-stone-500 mt-5 text-center">
            Déjà inscrit ?{" "}
            <Link to="/login" className="text-stone-900 font-medium underline underline-offset-4" data-testid="link-login">
              Se connecter
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
